module.exports = __webpack_public_path__ + "media/custom/images/img33-2fa027132ecc4bcdc94cccb065fbf29f.jpg";